import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';
import { useSignup } from '../../../contexts/SignupContext';

const getDemoPanDetails = (panNumber) => ({
  namePanCard: 'Demo User',
  panNumber,
  status: 'VALID',
});

const SignupPan = () => {
  const navigate = useNavigate();
  const { signupState, updateSignupState } = useSignup();
  const [panNumber, setPanNumber] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!signupState.otpVerified) {
      navigate('/signup/otp', { replace: true });
    }
  }, [signupState.otpVerified, navigate]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panNumber)) {
      toast.error('Please enter a valid PAN number');
      return;
    }

    setLoading(true);

    const details = getDemoPanDetails(panNumber.toUpperCase());

    updateSignupState({
      panDetails: details,
    });

    toast.success('PAN verified successfully');
    navigate('/signup/aadhaar');
    setLoading(false);
  };

  const handleBack = () => {
    navigate('/signup/otp');
  };

  return (
    <AuthLayout
      title="Verify PAN"
      subtitle="Verify your PAN to continue or skip to upload"
      onBack={handleBack}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">PAN Number</label>
          <input
            type="text"
            className="form-input"
            value={panNumber}
            onChange={(event) => setPanNumber(event.target.value.toUpperCase())}
            placeholder="ABCDE1234F"
            maxLength={10}
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify PAN'}
        </button>
      </form>
      <div className="signup-section" style={{ marginTop: '1.5rem' }}>
        <p className="signup-text">
          Prefer manual upload?{' '}
          <button
            type="button"
            className="signup-link"
            onClick={() => navigate('/signup/pan-upload')}
          >
            Skip and upload PAN
          </button>
        </p>
      </div>
      {signupState?.panDetails?.namePanCard && (
        <div
          style={{
            marginTop: '1.5rem',
            padding: '1rem',
            borderRadius: '12px',
            background: '#f8fafc',
            border: '1px solid #e2e8f0',
          }}
        >
          <h4 style={{ marginBottom: '0.75rem' }}>PAN Preview</h4>
          <p><strong>Name:</strong> {signupState.panDetails.namePanCard}</p>
          <p><strong>PAN:</strong> {signupState.panDetails.panNumber}</p>
        </div>
      )}
    </AuthLayout>
  );
};

export default SignupPan;


